import { useCallback, useEffect } from 'react';
import useICS2Codelists from './useICS2Codelists';
import { ICS2CodelistsMap } from 'store/codelists/code';

/**
 * Resolves a CL723 functional error code to its meaning. Customs sends only the code on every error
 * of an IE3N01 or IE3N99, so the description has to come from the codelist.
 *
 * Returns the code itself while the codelist is still loading, or when customs sends one it does
 * not contain.
 */
const useIcs2FunctionalErrorLabel = () => {
    const { ics2Codelists, preloadICS2Codelists } = useICS2Codelists();

    useEffect(() => {
        preloadICS2Codelists([ICS2CodelistsMap.CL723]);
    }, [preloadICS2Codelists]);

    return useCallback(
        (validationCode: string | undefined | null) =>
            validationCode
                ? ics2Codelists?.[ICS2CodelistsMap.CL723]?.find((item) => item.id === validationCode)?.value ??
                  validationCode
                : undefined,
        [ics2Codelists]
    );
};

export default useIcs2FunctionalErrorLabel;
